function getStoredChecked(fieldName: string): Set<string> {
  let storedCheckedStr = sessionStorage.getItem(fieldName);
  return storedCheckedStr
    ? new Set([...JSON.parse(storedCheckedStr)])
    : (new Set() as Set<string>);
}

export default getStoredChecked;
